import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParameterType, UserCaptureSourceRoleView } from '../../_generated';
import { AuthState } from '../reducers/auth.reducer';
import { getDataType } from './data-type.selector';
import RoleEnum = UserCaptureSourceRoleView.RoleEnum;

export const getAuthEntryFeatureState = createFeatureSelector<AuthState>('auth');

export const getUserCaptureSourceRoles = createSelector(
  getAuthEntryFeatureState,
  (state: AuthState) => state.user?.userCaptureSourceRole as Array<UserCaptureSourceRoleView>,
);

export const getUserParameterTypes = createSelector(
  getUserCaptureSourceRoles,
  // Iterate over the enum ParameterType to always return the parameter types in the same order
  // and check if the user has the role for the parameter type to return the user parameter types
  (captureSourceRoles: UserCaptureSourceRoleView[] | undefined) => {
    const parameterTypes: ParameterType[] = [];

    if (captureSourceRoles && captureSourceRoles.length > 0) {
      Object.values(ParameterType).forEach((parameterType) => {
        const hasRole = captureSourceRoles.some((captureSourceRole) => captureSourceRole.code === parameterType);
        if (hasRole) {
          parameterTypes.push(parameterType);
        }
      });
    }
    return parameterTypes;
  },
);

export const canUserEditEntry = createSelector(
  getDataType,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    return captureSourceRoles?.some((captureSourceRole) => captureSourceRole.code === dataType);
  },
);

export const canUserReviewEntry = createSelector(
  getDataType,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    return captureSourceRoles?.some((captureSourceRole) => captureSourceRole.role !== RoleEnum.preparer && captureSourceRole.code === dataType);
  },
);

export const canUserSubmitShop = createSelector(
  getDataType,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    return captureSourceRoles?.some((captureSourceRole) => captureSourceRole.code === dataType);
  },
);

export const canUserApproveEntry = createSelector(
  getDataType,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    return captureSourceRoles?.some((captureSourceRole) => captureSourceRole.role === RoleEnum.approver && captureSourceRole.code === dataType);
  },
);

export const canUserSubmitToCorpo = createSelector(
  getDataType,
  getUserCaptureSourceRoles,
  (dataType: ParameterType, captureSourceRoles: UserCaptureSourceRoleView[]) => {
    return captureSourceRoles?.some((captureSourceRole) => captureSourceRole.role === RoleEnum.approver && captureSourceRole.code === dataType);
  },
);
